import React, { useEffect, useState, memo, ReactNode } from 'react'
import { View } from 'react-native'

import TextMessage from 'APP/Components/Chat/TextMessage'
import ContentIcon from 'APP/Components/ContentIcon'
import Config from 'APP/Config'
import ContentCard from 'APP/Converse/ContentCard'
import { getColourScheme } from 'APP/Helpers/AppearanceUtils'
import { useSelector } from 'APP/Hooks/redux'
import { usePostContext } from 'APP/Lib/Context'
import { getContentType } from 'APP/Lib/ContentHelpers'
import { logger } from 'APP/Lib/Datadog'
import { navigationRef as Nav } from 'APP/Nav'
import { getCmsContent } from 'APP/Services/CMS'
import I18n from 'APP/I18n'
import { Document } from 'APP/Store/Content/types'

type Content = Partial<Document> & {
  loading: boolean
  icon?: ReactNode
  imageUrl?: string
}

const MAX_WIDTH = 300

const CmsContent = () => {
  // While BM sends the CMS content ID according to the user's preferred language,
  // the locale is still needed for CMS articles.
  const profile = useSelector((state) => state.patient?.profile)
  const locale = profile?.preferred_language || 'en'

  const { post } = usePostContext()
  const link = (post?.props?.choices || [])[0]?.link

  const [content, setContent] = useState<Content>({ loading: true })

  const style = getColourScheme()

  const onPress = () => {
    Nav.navigate('cmsScreen', {
      uri: `${Config.CMS.baseUrl}${link}?style=${style}&locale=${locale}`,
    })
  }

  useEffect(() => {
    if (!link) return
    const fetchData = async () => {
      try {
        const fetchedData = await getCmsContent(link, style, true, locale)

        setContent({
          icon: <ContentIcon type={getContentType(fetchedData)} />,
          imageUrl: fetchedData?.thumbnail?.url,
          length: fetchedData?.length,
          title: fetchedData?.title,
          notice: fetchedData?.notice,
          loading: false,
        })
      } catch (error) {
        logger.error('Failed to fetch CMS content', {}, error)
      }
    }
    fetchData()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [link])

  const showInfoSection = !!content?.length

  return (
    <View testID="CMS_CONTENT_VIEW">
      <TextMessage />
      {!content.loading && (
        <ContentCard
          testID="CMS_CONTENT_CARD_LINK"
          title={content?.title || ''}
          onPress={onPress}
          icon={showInfoSection ? content?.icon : null}
          info={showInfoSection ? `${content?.length} ${I18n.t('Common.minutes')}` : ''}
          imageUrl={content?.imageUrl ?? ''}
          notice={content?.notice}
          maxWidth={MAX_WIDTH}
        />
      )}
    </View>
  )
}

export default memo(CmsContent)
